import { createReducer, on } from "@ngrx/store";
import { updateState } from "@obg/ngx.global";

import { KycVerificationAction } from "./kyc-verification.action";

export interface KycVerificationState {
	kycVerification: {
		uri: string | undefined;
		isBusy: boolean;
		height: number;
	};
}

const initialState: KycVerificationState["kycVerification"] = {
	uri: undefined,
	isBusy: false,
	height: 1000,
};

export const kycVerificationSelector = createReducer(
	initialState,
	on(KycVerificationAction.getKnowYourCustomerUrl, (state) => updateState(state, { isBusy: true, uri: undefined })),
	on(KycVerificationAction.getKnowYourCustomerUrlSuccess, (state, { uri }) =>
		updateState(state, { uri, isBusy: false })
	),
	on(KycVerificationAction.getKnowYourCustomerUrlFail, (state) =>
		updateState(state, { isBusy: false, uri: undefined })
	),
	on(KycVerificationAction.getIframeHeight, (state, { payload }) => updateState(state, { height: payload }))
);
